<template>
  <v-toolbar id="core-toolbar" flat prominent style="background: #eee;">
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn v-if="responsive" class="default v-btn--simple" dark icon @click.stop="onClickBtn">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer/>
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <router-link v-ripple class="toolbar-items" to="/user-profile">
          <v-icon color="tertiary">mdi-account</v-icon>
        </router-link>

        <!-- <v-menu bottom left content-class="dropdown-menu" offset-y transition="slide-y-transition">
          <router-link v-ripple slot="activator" class="toolbar-items" to>
            <img :src="currLang.img">
          </router-link>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="(lang,code) in languages"
                :key="code"
                @click="onChangeLang(lang,code)"
              >
                <v-list-tile-action>
                  <img :src="lang.img">
                </v-list-tile-action>
                <v-list-tile-title>{{lang.name}}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>-->
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  data: () => ({
    notifications: [
      'Mike, John responded to your email',
      'You have 5 new tasks',
      "You're now a friend with Andrew",
      'Another Notification',
      'Another One'
    ],
    languages: {
      'en-US': {
        name: 'English',
        img: './img/us.png'
      },
      'zh-CN': {
        name: '中文',
        img: './img/cn.png'
      }
    },
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  computed: {
    currLang() {
      return this.languages[this.$locale]
    }
  },

  watch: {
    $route(val) {
      this.title = this.$title || val.name
    }
  },

  mounted() {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    onChangeLang(lang, code) {
      this.$locale = code
    }
  }
}
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
</style>
